/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { GenericApiResponseOralExamAggregateTimeSlotStateResponseData } from './genericApiResponseOralExamAggregateTimeSlotStateResponseData';
import type { GenericApiResponseOralExamAggregateTimeSlotStateResponseMessage } from './genericApiResponseOralExamAggregateTimeSlotStateResponseMessage';
import type { GenericApiResponseOralExamAggregateTimeSlotStateResponsePagination } from './genericApiResponseOralExamAggregateTimeSlotStateResponsePagination';
import type { GenericApiResponseOralExamAggregateTimeSlotStateResponseError } from './genericApiResponseOralExamAggregateTimeSlotStateResponseError';

export interface GenericApiResponseOralExamAggregateTimeSlotStateResponse {
  data?: GenericApiResponseOralExamAggregateTimeSlotStateResponseData;
  message?: GenericApiResponseOralExamAggregateTimeSlotStateResponseMessage;
  pagination?: GenericApiResponseOralExamAggregateTimeSlotStateResponsePagination;
  error?: GenericApiResponseOralExamAggregateTimeSlotStateResponseError;
  statusCode?: number;
}
